'use strict';require('../../style/css');
require('../../icon/style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/nav-bar/style/css.web.js
// module id = 228
// module chunks = 0